/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { ChallengeResponseWithAcceptance } from './ChallengeResponseWithAcceptance';
import {
    ChallengeResponseWithAcceptanceFromJSON,
    ChallengeResponseWithAcceptanceFromJSONTyped,
    ChallengeResponseWithAcceptanceToJSON,
    ChallengeResponseWithAcceptanceToJSONTyped,
} from './ChallengeResponseWithAcceptance';

/**
 * 
 * @export
 * @interface GetChallengesResponse
 */
export interface GetChallengesResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetChallengesResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<ChallengeResponseWithAcceptance>}
     * @memberof GetChallengesResponse
     */
    challenges: Array<ChallengeResponseWithAcceptance>;
}

/**
 * Check if a given object implements the GetChallengesResponse interface.
 */
export function instanceOfGetChallengesResponse(value: object): value is GetChallengesResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('challenges' in value) || value['challenges'] === undefined) return false;
    return true;
}

export function GetChallengesResponseFromJSON(json: any): GetChallengesResponse {
    return GetChallengesResponseFromJSONTyped(json, false);
}

export function GetChallengesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetChallengesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'challenges': ((json['challenges'] as Array<any>).map(ChallengeResponseWithAcceptanceFromJSON)),
    };
}

export function GetChallengesResponseToJSON(json: any): GetChallengesResponse {
    return GetChallengesResponseToJSONTyped(json, false);
}

export function GetChallengesResponseToJSONTyped(value?: GetChallengesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'challenges': ((value['challenges'] as Array<any>).map(ChallengeResponseWithAcceptanceToJSON)),
    };
}

